// extracted by mini-css-extract-plugin
export var baseMailListItemColor = "UWKUc";
export var flaggedMailListItemColor = "iZbPU";
export var regularMailListItemColor = "IjQyD";
export var selectedMailListItemColor = "epBmH";